import { useState, useEffect } from 'react';

export const usePasswordValidation = ({ passwordValue = '', confirmPasswordValue = '' }) => {
  const [mixedCases, setMixedCases] = useState(null);
  const [hasNumber, setHasNumber] = useState(null);

  useEffect(() => {
    setMixedCases(passwordValue.toLowerCase() !== passwordValue && passwordValue.toUpperCase() !== passwordValue);
    setHasNumber(/\d/.test(passwordValue));
  }, [passwordValue, confirmPasswordValue]);

  return [mixedCases, hasNumber];
};
